// src/config/statuts.config.ts — SCE Issues
// Couleurs des statuts : UNE source pour tout l'écran (check-up du Lot 8).
//
// ─── Ce que ça corrige ───
//
// Quatre écrans donnaient chacun leur couleur aux statuts :
//   badge            Ouvert gris clair   En cours gris foncé
//   tableau de bord  Ouvert gris foncé   En cours ORANGE (celui de MECA)
//   fiche équipement Ouvert ROUGE (celui de Critique)
//   fiche projet     Ouvert gris texte   En cours noir
// « Ouvert » se lisait donc tour à tour « rien de grave », « en cours »
// ou « critique ».
//
// ─── La règle (arbitrage du 25/09 : celle du badge) ───
//
// L'intensité suit l'engagement : Ouvert (en attente) clair, En cours
// (qualifié, quelqu'un s'en occupe) foncé, Clos vert, Annulé gris barré.
// Aucune teinte métier : l'orange a quitté les statuts, il n'y a plus de
// badge « En cours » qui ressemble à un badge MECA.

import type { CSSProperties } from 'react'
import type { Statut } from '@/types/issue.types'

export interface CouleursStatut {
  /** Style du badge (fond, texte, bordure, barré). */
  badge: CSSProperties
  /** Aplat d'une barre ou d'une pastille de légende (tableau de bord). */
  barre: string
}

// Record<Statut> : un statut ajouté sans couleur est une erreur de
// compilation, pas un badge vide.
export const STATUTS_COULEURS: Record<Statut, CouleursStatut> = {
  Ouvert: {
    badge: {
      backgroundColor: 'var(--color-gray-10)',
      color: 'var(--color-black)',
      border: '1px solid var(--color-gray-20)',
    },
    // Gris 40 et non gris 10 : un aplat gris 10 disparaît sur une carte blanche.
    barre: 'var(--color-gray-40)',
  },
  'En cours': {
    badge: {
      backgroundColor: 'var(--color-gray-90)',
      color: 'var(--color-white)',
    },
    barre: 'var(--color-gray-90)',
  },
  Clos: {
    badge: {
      backgroundColor: 'var(--color-traffic-green)',
      color: 'var(--color-white)',
    },
    barre: 'var(--color-traffic-green)',
  },
  // Barré : se lit « annulé » avant même d'être lu, y compris par un opérateur
  // qui balaie la liste du pouce. Sans fond : un annulé n'est pas un résultat,
  // il ne doit concurrencer ni le vert du Clos ni le gris plein de l'En cours.
  'Annulé': {
    badge: {
      backgroundColor: 'var(--color-white)',
      color: 'var(--color-gray-70)',
      border: '1px solid var(--color-gray-40)',
      textDecoration: 'line-through',
    },
    barre: 'var(--color-gray-20)',
  },
}
